module.exports = __webpack_public_path__ + "static/media/Mapleview Developments Ltd - Statement of Allegations Summary - 042024.8951a652.pdf";